import React from 'react'

class GranulatorComponent extends React.Component {
    render() {
        return <div  id="content">
        <div  className="video">
                <iframe  allowfullscreen="" frameborder="0" src="http://www.youtube.com/embed/9MUI6qVz8GY"></iframe>
                <iframe  allowfullscreen="" frameborder="0" src="https://www.youtube.com/embed/nPUdfe8A3K8"></iframe>
                <iframe  allowfullscreen="" frameborder="0" src="https://www.youtube.com/embed/s94X52EEl1c"></iframe>
        </div>
        
          
         
          <div  id="dsc">
              <h1 >Šiaudų (pjuvenų) granulių gamybos linijos  </h1>
              <p >
                  Maksimalus našumas -500/700/1000/1400/2000 kg/h pasiekiamas, kai žaliavos drėgmė 14%.
                  Gaminamos granulės 6,8 ir 12mm diametro ir 20-40mm ilgio. Linija dirba nepertraukiamu ritmu: 24val/ 7d. per savaitę. Linijos aptarnavimui 8 d. val. reikalingas vienas operatorius, kuris valdydamas pultą, paduoda rulonus, pakeičia Big-bag maišus ir perduoda produkciją į sandėlį.
                  Smulkinimui galima naudoti šiaudų rulonus, kurių diametras 150 cm arba
                  bloko formos-150×150 cm. Gamybai galima naudoti ir nepakuotą žaliavą, tik ji turi atitikti drėgmės reikalavimą.
                  Pagrindiniai granulių gamybos linijos įrenginiai:
              </p>
              <div className="images">
                  <img  src={require("./granuliatoriai/1.jpg")}/>
                  <img  src={require("./granuliatoriai/2.gif")}/>
                  <img  src={require("./granuliatoriai/3.jpg")}/>
              </div>
              <ul >
                  <li >žaliavos padavimo transporteris</li>
                  <li >separatorius</li>
                  <li >smulkintuvas</li>
                  <li >pneumatinis padavimas į talpą</li>
                  <li >tarpinis bunkeris-kaupiklis(su filtravimu nuo nuosėdų)</li>
                  <li >dozavimo įrenginys-šnekinis padavimo į presą transporteris</li>
                  <li >vibracinis iš valalantis konvejeris</li>
                  <li >skirstomasis skydas</li>
                  <li >valdymo ir kontrolės pultas</li>
              </ul>
        
                  
                 <p >Galimi papildomi įrenginiai</p> 
                 <ul >
                    <li >talpa ir šnekinis transporteris, džiovykla, transporteris ir kt.
                        Linijos našumas atskiroms žaliavoms: 700/ 1000/ 1400/ 2000 kg/h-kai šiaudų drėgmė 14%.
                        
                        Elektros galia-100/ 150/ 170/ 224 kW, eksploatacinis galingumas 100 kW tonai.
                        Reikalinga patalpa- 60m2, aukštis- 6m.</li>
                    <li ></li>
                    <li >
                        pasiektas triukšmo sumažinimo lygis iki 80 db;.
                    </li>
                    <li >pateikta technologija leidžia medžiagą sumaišyti uždaroje aplinkoje</li>
                    <li >išvengiama padidėjusio dulkėtumo.</li>
                    <li >linija atitinka EN ISO reikalavimus(elektros sujungimai, sanitarija, saugumas)</li>
                    <li >tai kompaktiška gamybinė linija nuo žaliavos pateikimo iki granulių
                        supakavimo. Subalansuoti įrengimai ir surikiuotas viso technologinio
                        proceso darbas</li>
                    <li >automatinis linijos valdymas, reguliavimas.</li>	
                 </ul>
            </div>
        
        </div>;
    }
}

export default GranulatorComponent